module.exports = {
          srcSet: __webpack_public_path__ + "4eb8fa8276f3a231803614a7f5a3a9ce-488.png"+" 488w",
          images:[ {path: __webpack_public_path__ + "4eb8fa8276f3a231803614a7f5a3a9ce-488.png",width: 488,height: 489}],
          src: __webpack_public_path__ + "4eb8fa8276f3a231803614a7f5a3a9ce-488.png",
          toString:function(){return __webpack_public_path__ + "4eb8fa8276f3a231803614a7f5a3a9ce-488.png"},
          
          width: 488,
          height: 489
        }